import * as domain from "../domain";
import { telemetryService } from "./";
import { getKeyFromStorage } from "./storage-utils";

let LOCAL_STORAGE_KEY = "relode:v2:user:key";
let cachedUser: AuthenticatedUser | undefined = undefined;
export const setStorageKey = (version: string) => {
    LOCAL_STORAGE_KEY = `relode:${version}:user:key`;
};

export interface AuthenticatedUser {
    token: string;
    userId: number;
    firstName: string;
    email: string;
    displayName: string;
    profileImageUrl: string;
    expires: string;
    roleId: number;
    role: domain.UserRole;
    applicationName: string | undefined;
}

export const getUserFromStorage = (): AuthenticatedUser | undefined => {
    const userItem = getKeyFromStorage(LOCAL_STORAGE_KEY);

    if (!userItem) {
        unauthorizeCachedUser();
        return cachedUser;
    }

    const user = JSON.parse(userItem);

    if (!user) {
        unauthorizeCachedUser();
        return cachedUser;
    }

    if (cachedUser?.token === user.token) {
        return cachedUser;
    }
    user.role = domain.UserRole.fromId(user.roleId);
    cachedUser = user;
    return cachedUser;
};

const unauthorizeCachedUser = () => {
    // if we have a cached user then we want to keep it, just remove the token so that api calls will not authorize.
    // we need to keep the cached user (rather than just set to undefined) because there are areas that will
    // attempt to use the user outside of an API call.  This allows them to access those properties it may need;
    // including the now blank token.
    if (!!cachedUser) {
        //cachedUser.token = "";
        cachedUser = { ...cachedUser, token: "" };
    }
};

export const isCurrentUserAdministrator = (): boolean => {
    const user = getUserFromStorage();
    if (user && user.roleId === domain.UserRole.Administrator.roleId)
        return true;
    return false;
};

export const isCurrentUserAccounting = (): boolean => {
    const user = getUserFromStorage();
    if (user && user.roleId === domain.UserRole.Accounting.roleId) return true;
    return false;
};

export const setUserInStorage = (user: any) => {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(user));
};

export const removeUserFromStorage = () => {
    cachedUser = undefined;
    telemetryService.userLogout();
    localStorage.removeItem(LOCAL_STORAGE_KEY);
};
